import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	Signal,
} from '@angular/core';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Store } from '@ngxs/store';
import { BusinessDispatch, BusinessState } from '@state/business';
import { map } from 'rxjs';
import { IDVProvider } from '@models/idv';
import { ContentHeaderTitleImg } from 'src/app/ui/content-header/content-header.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { BusinessSettingsCardProvidersFirestorePaths } from '../business-finances-general/business-finances-general.types';
import { BaseBusinessSettingsSection } from '../business-finances-general/common/base-business-settings-section/base-business-settings-section.directive';
import { TestHooks } from './idv-general.hooks';

@Component({
	selector: 'app-idv-general',
	templateUrl: './idv-general.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class IdvGeneralComponent extends BaseBusinessSettingsSection {
	testHooks = TestHooks;
	@ViewSelectSnapshot(BusinessState.getTreefortConnected)
	isTreefortConnected: boolean;

	private businessDispatch: BusinessDispatch = inject(BusinessDispatch);

	public defaultProviderSignal = toSignal(
		inject(Store)
			.select(BusinessState.getDefaultIdvProvider)
			.pipe(
				map((provider) =>
					provider === IDVProvider.NOT_SELECTED ? IDVProvider.MANUAL : provider,
				),
			),
	);

	public titleImgConfigSignal: Signal<ContentHeaderTitleImg> = computed(() => {
		const currIdvProvider = this.defaultProviderSignal();

		const matchedProvider = this.idvProviders.find(
			(option) => option.value === currIdvProvider,
		);

		if (!matchedProvider || !matchedProvider.imagePath) return null;

		return {
			imgSrc: matchedProvider.imagePath,
			altText: matchedProvider.label,
		};
	});

	public idvProviders = [
		{
			value: IDVProvider.TREEFORT,
			imagePath: '/assets/images/integrations/treefort-logo.svg',
			label: 'Treefort',
		},
		{
			value: IDVProvider.MANUAL,
			label: 'Manual',
		},
	];

	setDefaultProvider(provider: IDVProvider): void {
		const currProvider = this.defaultProviderSignal();

		if (provider === currProvider) return;

		const fieldToUpdate = BusinessSettingsCardProvidersFirestorePaths.IDV;

		this.businessDispatch.OverwriteBusinessFields(
			`defaultSettings.${fieldToUpdate}.defaultProvider`,
			provider,
		);
	}
}
